export default function initSectorsGridCarousel(Swiper, Navigation, Autoplay) {
    // ==========================================================
    // SECTORS GRID
    // ==========================================================

    const sliders = document.querySelectorAll("[data-sectors-slider]");

    if (!sliders.length) {
        return;
    }

    sliders.forEach((slider) => {
        // ======================================================
        // NAVIGATION
        // ======================================================

        const section = slider.closest("[data-sectors-grid]");

        if (!section) {
            return;
        }

        const prev = section.querySelector(".sectors-grid__arrow--prev");

        const next = section.querySelector(".sectors-grid__arrow--next");

        // ======================================================
        // SWIPER
        // ======================================================

        const swiper = new Swiper(slider, {
            modules: [Navigation, Autoplay],

            // --------------------------------------------------
            // GENERAL
            // --------------------------------------------------

            loop: false,

            watchOverflow: true,

            observer: true,

            observeParents: true,

            grabCursor: true,

            speed: 650,

            // --------------------------------------------------
            // MOBILE
            // --------------------------------------------------

            slidesPerView: 1.15,

            spaceBetween: 16,

            // --------------------------------------------------
            // AUTOPLAY
            // --------------------------------------------------

            autoplay: {
                delay: 3500,

                disableOnInteraction: false,

                pauseOnMouseEnter: true,
            },

            // --------------------------------------------------
            // NAVIGATION
            // --------------------------------------------------

            navigation: {
                prevEl: prev,
                nextEl: next,
            },

            // --------------------------------------------------
            // RESPONSIVE
            // --------------------------------------------------

            breakpoints: {
                640: {
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                },

                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },

                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },

                1300: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
            },

            // --------------------------------------------------
            // ACCESSIBILITÉ / CLASSES
            // --------------------------------------------------

            on: {
                init(swiperInstance) {
                    updateActiveCard(swiperInstance);
                },

                slideChange(swiperInstance) {
                    updateActiveCard(swiperInstance);
                },
            },
        });

        // ======================================================
        // ACTIVE CARD
        // ======================================================

        function updateActiveCard(swiperInstance) {
            const cards = slider.querySelectorAll("[data-sector-card]");

            cards.forEach((card) => {
                card.classList.remove("is-active");
            });

            const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];

            if (activeSlide) {
                activeSlide.classList.add("is-active");
            }
        }

        // ======================================================
        // RESIZE
        // ======================================================

        window.addEventListener(
            "resize",
            () => {
                swiper.update();
            },
            {
                passive: true,
            },
        );
    });
}
